// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__28VRa","errorLogs":"styles_errorLogs__2QeGT"};